module.exports = __webpack_public_path__ + "fonts/f8abf68e-0fda-4e20-ab06-995b353028ee.0416b340.woff";